<template>
	<v-col
		cols="12"
		sm="6"
		md="3"
	>
		<nuxt-link
			:to="$routerHelper.getPathByRouteName('property-detail', { title: property.property_title, id })"
			:title="property.property_title"
		>
			<z-img
				:storage="property.mainImage"
				:alt="property.property_title"
				max-width="100%"
				max-height="200"
			/>
			<section>
				<h1 class="text-truncate colorRed">
					{{ property.property_title }}
				</h1>
				<h6 class="text-truncate black--text">
					{{ property.project }}
				</h6>
				<p class="text-truncate">
					{{ property.address_road ? `ถนน${property.address_road}` : '' }}
					{{ property.locationText }}
				</p>
			</section>
		</nuxt-link>
	</v-col>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	props: {
		id: {
			type: Number,
			default: null
		}
	},
	data:() => ({
		property: null
	}),
	computed: {
		...mapGetters({ 
			getLocation: 'getLocation',
			getProperty: 'property/getProperty' 
		})
	},
	created() {
		this.property = this.getProperty(this.id)
	}
}

</script>
